export const CMS_APP_DEF_ID = 'e593b0bd-b783-45b8-97c2-873d42aacaf4'
export const VIEWER_CORE_SERVICES_APP_DEFINITION_ID = '1a711f05-2040-47df-a9f0-4f9cddb4c3c6'
export const VELO_APP_DEFINITION_ID = '2f70e2b4-ff36-472e-bdb9-ce393b13669e'
export const MEMBERS_APP_DEFINITION_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9'
